import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#88D388",
      "fill-rule": "nonzero",
      d: "m20.163 19.484-4.046-4.208a6.84 6.84 0 0 0 1.61-4.412A6.87 6.87 0 0 0 10.864 4 6.87 6.87 0 0 0 4 10.864a6.87 6.87 0 0 0 6.864 6.863 6.8 6.8 0 0 0 3.932-1.242l4.077 4.24a.89.89 0 0 0 1.266.025.896.896 0 0 0 .024-1.266m-9.3-13.693a5.08 5.08 0 0 1 5.074 5.073 5.08 5.08 0 0 1-5.073 5.073 5.08 5.08 0 0 1-5.073-5.073 5.08 5.08 0 0 1 5.073-5.073"
    }, null, -1)
  ]))]))
}
export default { render: render }